import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import LazyLoadImage from "../../../LazyLoadImage/LazyLoadImage";
import ListingSwiperPhotos from "../../ListingSwiperPhotos/ListingSwiperPhotos";

import { isRTL } from "../../../../helpers/formatLocale";
import { formatURL } from "../../../../helpers/formatURL";

import mediumNoImage from '/public/SiteImages/medium_no_image.png';
import largeNoImage from '/public/SiteImages/large_no_image.jpeg';

const CommonListingPhotos = (props) => {
  const {
    className,
    placeholderClassName,
    photoType,
    lazyLoad,
    bgImage,
    isListingSwiper,
    locale,
    coverPhoto,
    listPhotos = [],
    title,
    id,
    updatedLocale,
    children,
  } = props;

  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (listPhotos?.length > 0) {
      let activePhoto = listPhotos[0].name;
      if (coverPhoto) {
        const cover = listPhotos.find((item) => item.id === coverPhoto);
        if (cover) activePhoto = cover.name;
      }
      setPhoto(activePhoto);
    }
  }, [JSON.stringify(listPhotos), coverPhoto]); // Ensures update when list changes

  let path = "", source;

  if (photo) {
    source = photo;
    if (photoType) path = "/images/upload/x_medium_";
  } else if (listPhotos.length > 0) {
    source = listPhotos[0].name;
    if (coverPhoto) {
        const cover = listPhotos.find((item) => item.id === coverPhoto);
        if (cover) source = cover.name;
      }
    if (photoType) path = "/images/upload/x_medium_";
  } else {
    if (photoType === "x_medium") source = largeNoImage;
    else if (photoType === "x_small") source = mediumNoImage;
    else source = mediumNoImage;
  }

  let activeItem = 0;
  const photosList = listPhotos.slice();

  if (listPhotos.length > 1) {
    listPhotos.forEach((x, y) => {
      if (x.id === coverPhoto) activeItem = y;
    });
    if (activeItem > 0) {
      const temp = photosList[0];
      photosList[0] = photosList[activeItem];
      photosList[activeItem] = temp;
    }
  }

  const link = `/rooms/${formatURL(title)}-${id}`;

  if (isListingSwiper) {
    return (
      <ListingSwiperPhotos
        id={id}
        coverPhoto={coverPhoto}
        listPhotos={photosList}
        title={title}
        rtl={isRTL(locale)}
        updatedLocale={updatedLocale}
      />
    );
  } else if (lazyLoad && bgImage) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <LazyLoadImage
          src={`${path}${source}`}
          placeholderSrc={`/images/upload/placeholder_${source}`}
          className={className}
          placeholderClassName={placeholderClassName}
        />
      </a>
    );
  } else if (bgImage) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className={className} style={{ backgroundImage: `url(${path}${source})` }}>
          {children}
        </div>
      </a>
    );
  } else {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        <div className={className} style={{ backgroundImage: `url(${path}${source})` }} />
      </a>
    );
  }
};

const mapState = (state) => ({
  locale: state.intl.locale,
  updatedLocale: state?.intl?.newLocale,
});

export default connect(mapState)(CommonListingPhotos);
